import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { isEmpty } from 'lodash';
import ClaimJobDataPointsInputs, {
  getVisibleDataPoints,
} from 'module/claims/views/claim/other/Claim.Job.DataPoints.Inputs';
import { ClaimJobProps, usePublicClaimSubmitProvider } from '../../Claim.Submit.Hooks';

export default function ClaimSubmitClaimJobDataPoints({ claimJob, index }: ClaimJobProps) {
  const { lang } = getLocales();
  const { form, updateDetail } = usePublicClaimSubmitProvider();

  const claimJobs = form.data?.claim?.claimJobs || [];
  const visibleDataPoints = getVisibleDataPoints(claimJob?.dataPoints);

  return !isEmpty(visibleDataPoints) ? (
    <div
      key={index}
      style={{
        marginLeft: Theme.Size.L,
        marginRight: Theme.Size.L,
        marginBottom: Theme.Size.XL,
      }}
    >
      <h2 style={{ display: 'flex', justifyContent: 'space-between' }}>
        {`${lang.details} ${claimJobs.length > 1 ? `#${index + 1}` : ''}`}
      </h2>
      <ClaimJobDataPointsInputs dataPoints={visibleDataPoints} onUpdate={(val, id) => updateDetail(index, val, id)} />
    </div>
  ) : null;
}
